import { createAction, props } from '@ngrx/store';
import { SidebarInterface, SidebarWarnings } from '../../../core/interfaces';
import { StartupFailureKind } from '../../../core/services/startup-failure';

export const fetchSidebar = createAction('[@ciso/sidebar] fetchSidebar');

export const fetchSidebar_Success = createAction(
  '[@ciso/sidebar] fetchSidebar_Success',
  props<{ sidebar: SidebarInterface[] }>(),
);

/**
 * Task 2616 Phase 7 — dispatched when the NavBar API call fails.
 * Phase 8 adds `outcomeCode` (X-CM-Auth-Outcome) so the access-denied page can
 * decide whether to show the "Sign in again" recovery button.
 */
export const fetchSidebar_Failure = createAction(
  '[@ciso/sidebar] fetchSidebar_Failure',
  props<{ failureKind: StartupFailureKind; outcomeCode: string }>(),
);
export const setSettingItems = createAction(
  '[@ciso/sidebar] setSettingItems',
  props<{ settingItems: SidebarInterface }>(),
);

export const fetchSidebarWarnings = createAction('[@ciso/sidebar] fetchSidebarWarnings');

export const fetchSidebarWarnings_Success = createAction(
  '[@ciso/sidebar] fetchSidebarWarnings_Success',
  props<{warnings: SidebarWarnings}>(),
);

export const fetchSidebarWarnings_Failure = createAction(
  '[@ciso/sidebar] fetchSidebarWarnings_Failure',
);